import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/message',
    name: 'Message',
    component: Main,
    meta: {
      disabled: true,
      label: '消息管理'
    },
    children: [
      {
        name: 'MessageClass',
        path: 'class',
        component: () => import('@/views/Message/Class/classList'),
        meta: {
          label: '标签类型管理',
        },
      },
      {
        name: 'MessageClassParent',
        path: 'class',
        component: ParentView,
        redirect: {name: 'MessageClass'},
        meta: {
          label: '标签类型管理',
        },
        children: [
          {
            name: 'newMessageClass',
            path: 'newMessageClass',
            meta: {
              label: '新增标签类型'
            },
            component: () => import('@/views/Message/Class/classForm'),
          },
          {
            name: 'classDetailBox',
            path: 'detail',
            meta: {
              label: '标签类型详情'
            },
            component: () => import('@/views/Message/Class/classDetailBox'),
          }
        ]
      },
      {
        name: 'MessageLabel',
        path: 'label',
        component: () => import('@/views/Message/Label/labelList'),
        meta: {
          label: '消息标签管理',
        },
      },
      {
        name: 'MessageLabelParent',
        path: 'label',
        component: ParentView,
        redirect: {name: 'MessageLabel'},
        meta: {
          label: '消息标签管理',
        },
        children: [
          {
            name: 'newMessageLabel',
            path: 'newMessageLabel',
            meta: {
              label: '新增消息标签'
            },
            component: () => import('@/views/Message/Label/labelForm'),
          },
          {
            name: 'labelDetailBox',
            path: 'labelDetail',
            meta: {
              label: '消息标签详情'
            },
            component: () => import('@/views/Message/Label/labelDetailBox'),
          }
        ]
      },
      {
        name: 'MessageEvent',
        path: 'event',
        component: () => import('@/views/Message/Event/eventList'),
        meta: {
          label: '消息事件管理',
        },
      },
      {
        name: 'MessageEventParent',
        path: 'event',
        component: ParentView,
        redirect: {name: 'MessageEvent'},
        meta: {
          label: '标签事件管理',
        },
        children: [
          {
            name: 'newMessageEvent',
            path: 'newMessageEvent',
            meta: {
              label: '新增标签事件'
            },
            component: () => import('@/views/Message/Event/eventForm'),
          },
          {
            name: 'eventDetailBox',
            path: 'detail',
            meta: {
              label: '标签事件详情'
            },
            component: () => import('@/views/Message/Event/eventDetailBox'),
          }
        ]
      },
      {
        name: 'MessageTemplate',
        path: 'template',
        component: () => import('@/views/Message/Template/templateList'),
        meta: {
          label: '消息模板管理',
        },
      },
      {
        name: 'MessageTemplateParent',
        path: 'template',
        component: ParentView,
        redirect: {name: 'MessageTemplate'},
        meta: {
          label: '消息模板管理',
        },
        children: [
          {
            name: 'newMessageTemplate',
            path: 'newMessageTemplate',
            meta: {
              label: '新增消息模板'
            },
            component: () => import('@/views/Message/Template/templateForm'),
          },
          {
            name: 'templateDetailBox',
            path: 'detail',
            meta: {
              label: '消息模板详情'
            },
            component: () => import('@/views/Message/Template/templateDetailBox'),
          }
        ]
      },
      {
        name: 'sendConfig',
        path: 'send/sendConfig',
        component: () => import('@/views/Message/Send/sendConfigList'),
        meta: {
          label: '消息发送配置',
        },
      },
      {
        name: 'sendConfigParent',
        path: 'send/sendConfig',
        component: ParentView,
        redirect: {name: 'sendConfig'},
        meta: {
          label: '消息发送配置',
        },
        children: [
          {
            name: 'newSendConfig',
            path: 'new',
            component: () => import('@/views/Message/Send/sendConfigForm'),
            meta: {
              label: '新增消息发送配置',
            },
          },
        ]
      },
    ]
  }
]
